import UDModal from './modal';
import { ModalBody, ModalFooter, ModalHeader } from './modal-parts';

export * from './modal';
export * from './modal-parts';

// Compound component pattern
const Modal = Object.assign(UDModal, {
  Header: ModalHeader,
  Body: ModalBody,
  Footer: ModalFooter,
});

export default Modal;
